import { ComponentProps, isValidElement, memo, MouseEvent, useCallback } from 'react'
import cn from 'classnames'

import s from './ButtonIcon.module.less'

type TColor = 'white' | 'gray' | 'dark' | 'placeholder' | 'accent' | 'normal' | 'error'

export interface IProps extends ComponentProps<'div'> {
  icon: TSvgIconComponent | string
  color?: TColor
  containerSize?: ISvgIconProps['containerSize']
  disabled?: boolean
  innerRef?: (node: HTMLElement | null) => void
  onClick?: (event: MouseEvent) => void
  rotate?: ISvgIconProps['rotate']
  size?: ISvgIconProps['size']
}

export const ButtonIcon = memo(function ButtonIcon({
  icon: IconFromProps,
  className,
  color = 'normal',
  size = 'nm',
  rotate,
  containerSize,
  disabled,
  onClick,
  innerRef,
  ...rest
}: IProps) {
  const preparedClassName = cn(className, s.ButtonIcon, s[disabled ? 'disabled' : color])

  const handleClick = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation()

      if (onClick) {
        onClick(e)
      }
    },
    [onClick]
  )

  const iconElement = isValidElement(IconFromProps) ? (
    IconFromProps
  ) : (
    <IconFromProps containerSize={containerSize} rotate={rotate} size={size} />
  )

  return (
    <div {...rest} ref={innerRef} className={preparedClassName} onClick={disabled ? undefined : handleClick}>
      {iconElement}
    </div>
  )
})
